module.exports = __webpack_public_path__ + "static/media/feelingProud.88e3da52.svg";